const currency = {
  'pt-br': 'BRL',
  'en-US': 'USD'
};

const currencyFormatter = ({
  value = '',
  locale = 'pt-br',
  rightFilling = false,
  decimal = true
}) => new Intl.NumberFormat(locale, {
  style: 'currency',
  currency: currency[locale],
  minimumFractionDigits: decimal ? 2 : 0,
  maximumFractionDigits: decimal ? 2 : 0
}).format(rightFilling ? parseFloat(value / 100) : value);

export default currencyFormatter;